import { Company } from "@/app/types/Company";

/**
 * The single source of truth for the deal score shown anywhere in the UI
 * (tabs, lists, drawers, cards). Returns the formula-based dealScore the
 * backend computed from the user/team deal-opportunity report — the same
 * value the company page shows — or undefined (rendered as N/A).
 *
 * Never falls back to `maxScore` (buyer-intent score, a different metric)
 * and never shows backend intent-fallback placeholders
 * (dealScoreSource === 'intent_fallback'): those values are only used for
 * approximate ordering while the real score warms in the background, and
 * displaying them would disagree with the company page.
 */
export function getDisplayDealScore(company: Company): number | undefined {
  if (company.dealScoreSource === 'intent_fallback') {
    return undefined;
  }
  const dealScore = company.dealScore;
  return typeof dealScore === 'number' && dealScore > 0 ? dealScore : undefined;
}
